<template>
<b-modal
  id="datatable-v1-row-add-edit-modal-vix816"
  v-model="show"
  :title="row ? `Edit row ${row.index + 1}` : 'Add row'"
  centered
  no-close-on-backdrop
  header-bg-variant="primary"
  header-text-variant="white"
  @ok="ok"
  @cancel="cancel"
  @close="cancel"
  header-class="bg-purple"
>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button id="datatable-v1-row-add-edit-modal-noa1db" variant="secondary" @click="cancel()">
        Cancel
      </b-button>
      <b-button id="datatable-v1-row-add-edit-modal-hijex2" variant="primary" @click="ok()">
        Save
      </b-button>
    </template>

    <b-form-group v-for="(field, i) in fields" :key="field.key" :label="field.label" :id="'datatable-v1-row-add-edit-modal-njscxb-' + i">
      <v-select v-if="field.type == 'select'" :options="field.options" v-model="form[field.key]" :id="'datatable-v1-row-add-edit-modal-imlqpr-' + i"></v-select>
      <date-picker v-else-if="field.type == 'date'" v-model="form[field.key]" :id="'datatable-v1-row-add-edit-modal-7utctd-' + i"></date-picker>
      <time-picker v-else-if="field.type == 'time'" v-model="form[field.key]" :id="'datatable-v1-row-add-edit-modal-w7qgoo-' + i"></time-picker>
      <b-input v-else v-model="form[field.key]" :id="'datatable-v1-row-add-edit-modal-yxb5of-' + i"></b-input>
    </b-form-group>
  </b-modal>

</template>

<script>
import { mapGetters } from "vuex";
import {
  formatDateOnlyMysql,
  formatDateTimeSql,
  formatTimeOnlyMysql
} from "../../../../helpers/date";
import DatePicker from "../../../controls/DatePicker.vue";
import TimePicker from "../../../controls/TimePicker.vue";
export default {
  name: "DatatableV1RowAddEditModal",
  components: { DatePicker, TimePicker },
  props: ["fields", "row", "show"],
  data() {
    return {
      form: {}
    };
  },
  mounted() {
    if (this.row) {
      this.form = { ...this.row.item };
      this.fields.forEach(field => {
        if (field.type == "time") {
          this.form[field.key] = formatTimeOnlyMysql(this.form[field.key]);
        }
      });
    }
  },
  methods: {
    ok(e) {
      e.preventDefault();
      this.fields.forEach(field => {
        if (field.type == "time") {
          this.form[field.key] = formatDateTimeSql(
            formatDateOnlyMysql(this.getCurrentAdjustedDateTime()) +
              "T" +
              this.form[field.key]
          );
        }
      });
      this.$emit("ok", { data: this.form, index: this.row?.index });
    },
    cancel(e) {
      e.preventDefault();
      this.$emit("cancel");
    }
  },
  computed: {
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"])
  }
};
</script>

<style></style>
